import React, { useState } from 'react'
import {
  setErpDesignCatalogAuthed,
  verifyErpDesignCatalogPassword,
} from './erpDesignCatalogAuth'

export default function ErpDesignCatalogGate({ onAuthed }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const submit = (event) => {
    event.preventDefault()
    if (!verifyErpDesignCatalogPassword(password)) {
      setError('Senha incorreta.')
      return
    }
    setErpDesignCatalogAuthed()
    onAuthed()
  }

  return (
    <div className="erp-cat-gate">
      <form className="erp-cat-gate__card" onSubmit={submit}>
        <h1>Catálogo ERP</h1>
        <p>
          Design system e identidade visual Ecossis (MIV 2026). Informe a senha de acesso para
          abrir o catálogo.
        </p>
        <label className="erp-cat-gate__label" htmlFor="erp-design-catalog-password">
          Senha de acesso
        </label>
        <input
          id="erp-design-catalog-password"
          className="erp-cat-gate__input"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
            if (error) setError('')
          }}
        />
        {error ? <p className="erp-cat-gate__error">{error}</p> : null}
        <button type="submit" className="erp-cat-gate__btn">
          Entrar
        </button>
        <p className="erp-cat-gate__note">
          Uso interno Ecossis. Não compartilhe a senha fora do time autorizado.
        </p>
      </form>
    </div>
  )
}
